export function setEncodedCookie(name, value = 'CdSB_Valet', days) {
  const encodedValue = btoa(value); // Base64 encode
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = `${name}=${encodedValue}${expires}; path=/`;
};

export function getDecodedCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i].trim();
    if (c.indexOf(nameEQ) === 0) {
      const encodedValue = c.substring(nameEQ.length);
      try {
        return atob(encodedValue); // Base64 decode
      } catch (e) {
        console.error("Failed to decode cookie value:", e);
        return null;
      }
    }
  }
  return null;
};

export function deleteCookie(name) {
  document.cookie = `${name}=; Max-Age=0; path=/`;
}